var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { BundlePriceCompare, Button } from "@savvyinsure/react-ui";
import { ConnectIssuerIcon, SavvyIssuerIcon, } from "../../components/IssuerIcon";
import { convertCentsToDollars, shouldOpenInSameWindow } from "../../lib/util";
import AppBody from "../../components/AppBody";
import Header from "../../components/Header";
import { InsuranceType } from "../../constants";
import { PHASE } from "../../routeConfig";
import { ResultType } from "../../services/savvy/constants";
import classNames from "classnames";
import { completedPage } from "../../lib/Avo";
import { getMonthlyAutoPremium } from "../../services/savvy/utils";
import handleResultClick from "../../utils/handleResultClick";
import { rc2Issuers } from "../../lib/constants";
import { selectAutoBundleIssuer } from "../../features/applicant/applicantSlice";
import shouldShowFallbackIcon from "../../utils/shouldShowFallbackIcon";
import { skipToken } from "@reduxjs/toolkit/query";
import useAffiliateConfig from "../../hooks/useAffiliateConfig";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAppSelector from "../../hooks/useAppSelector";
import { useGetSearchResultsQuery } from "../../services/savvy";
import useImpressionType from "../../services/savvy/useImpressionType";
import useIsRemarketingSearch from "../../features/configuration/useIsRemarketingSearch";
import useMemoryHistory from "../../hooks/useMemoryHistory";
function getSubtitle(_a) {
    var isLinked = _a.isLinked, numOfSteps = _a.numOfSteps, hasSavings = _a.hasSavings;
    return (React.createElement(React.Fragment, null,
        !isLinked || !hasSavings ? ("Switch in ") : (React.createElement(React.Fragment, null,
            "Switch and start ",
            React.createElement("br", null),
            " saving in just", " ")),
        React.createElement("span", { className: "font-bold text-black-100" },
            numOfSteps,
            " steps.")));
}
function Subtitle(_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("h2", __assign({ className: classNames("mb-4 text-center text-2xl text-black-300", className) }, rest)));
}
function Step(_a) {
    var filled = _a.filled, step = _a.step, content = _a.content;
    return (React.createElement("div", { className: "flex items-center" },
        React.createElement("div", { className: classNames("mr-2 flex h-6 w-6 items-center justify-center rounded-full border-2 text-xs font-semibold leading-none", {
                "border-black-100 bg-black-100 text-white": filled,
                "border-gray-100 bg-[#FAFAFA] text-gray-100": !filled,
            }) }, step),
        React.createElement("p", { className: classNames("font-bold", { "text-gray-100": !filled }) }, content)));
}
function Steps(_a) {
    var steps = _a.steps;
    return (React.createElement("div", { className: "relative mb-4 md:mb-6" },
        React.createElement("div", { className: "absolute bottom-0 left-3 top-0 z-0 h-full w-0.5 bg-gray-100" }),
        React.createElement("div", { className: "relative z-10 space-y-4 md:space-y-6" }, steps.map(function (step, index) { return (React.createElement(Step, { key: step, step: index + 1, content: step, filled: index === 0 })); }))));
}
function getBundleSavings(_a) {
    var _b, _c;
    var currentPlan = _a.currentPlan, bundle = _a.bundle;
    var monthlyAutoPremium = getMonthlyAutoPremium(currentPlan);
    var currentAutoDollars = convertCentsToDollars(monthlyAutoPremium);
    var currentHomeDollars = convertCentsToDollars(currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.homeMonthlyPremiumCents);
    var bundleAutoDollars = convertCentsToDollars((_b = bundle === null || bundle === void 0 ? void 0 : bundle.auto) === null || _b === void 0 ? void 0 : _b.quoteMonthlyCents);
    var bundleHomeDollars = convertCentsToDollars((_c = bundle === null || bundle === void 0 ? void 0 : bundle.home) === null || _c === void 0 ? void 0 : _c.quoteMonthlyCents);
    var totalCurrentMonthlyDollars = currentAutoDollars + currentHomeDollars;
    var totalQuoteMonthlyDollars = bundleAutoDollars + bundleHomeDollars;
    var totalBundleSavings = totalCurrentMonthlyDollars - totalQuoteMonthlyDollars;
    return {
        totalBundleSavings: totalBundleSavings,
        bundleHomeDollars: bundleHomeDollars,
        bundleAutoDollars: bundleAutoDollars,
        currentAutoDollars: currentAutoDollars,
        currentHomeDollars: currentHomeDollars,
    };
}
function BundleSelectCompare(_a) {
    var _b, _c, _d, _e, _f, _g;
    var bundle = _a.bundle, isLinked = _a.isLinked, currentPlan = _a.currentPlan;
    var hideIssuerLogos = useAffiliateConfig().hideIssuerLogos;
    var _h = getBundleSavings({
        currentPlan: currentPlan,
        bundle: bundle,
    }), totalBundleSavings = _h.totalBundleSavings, bundleAutoDollars = _h.bundleAutoDollars, bundleHomeDollars = _h.bundleHomeDollars, currentAutoDollars = _h.currentAutoDollars, currentHomeDollars = _h.currentHomeDollars;
    var isAutoRC2 = ((_b = bundle === null || bundle === void 0 ? void 0 : bundle.auto) === null || _b === void 0 ? void 0 : _b.issuerId)
        ? rc2Issuers.includes((_c = bundle.auto) === null || _c === void 0 ? void 0 : _c.issuerId)
        : false;
    var isHomeRC2 = ((_d = bundle === null || bundle === void 0 ? void 0 : bundle.home) === null || _d === void 0 ? void 0 : _d.issuerId)
        ? rc2Issuers.includes((_e = bundle.home) === null || _e === void 0 ? void 0 : _e.issuerId)
        : false;
    var sameAutoPolicy = (bundle === null || bundle === void 0 ? void 0 : bundle.auto.type) === ResultType.CurrentAutoPolicy;
    var sameHomePolicy = (bundle === null || bundle === void 0 ? void 0 : bundle.home.type) === ResultType.CurrentHomePolicy;
    var samePolicy = sameAutoPolicy && sameHomePolicy;
    var isEstimate = !isAutoRC2 || !isHomeRC2;
    var hasSavings = totalBundleSavings > 0;
    if (!bundle) {
        return null;
    }
    return (React.createElement("div", { className: "mb-4 md:mb-6" },
        isLinked && hasSavings ? (React.createElement("h2", { className: "mb-4 text-center text-lg font-bold md:mb-6 md:text-xl" },
            "Save up to",
            " ",
            React.createElement("span", { className: "text-green" },
                "$",
                totalBundleSavings,
                "/month",
                isEstimate ? React.createElement("span", null, "*") : null),
            " ",
            "with this switch!")) : null,
        React.createElement(BundlePriceCompare, { current: currentAutoDollars && currentHomeDollars
                ? {
                    auto: {
                        price: currentAutoDollars,
                        logo: (React.createElement(ConnectIssuerIcon, { issuerId: currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.issuerId, fallback: shouldShowFallbackIcon(hideIssuerLogos, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.issuerId), size: "small", insuranceType: InsuranceType.Auto })),
                    },
                    home: {
                        price: currentHomeDollars,
                        logo: (React.createElement(SavvyIssuerIcon, { issuerId: currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.homeIssuerId, fallback: shouldShowFallbackIcon(hideIssuerLogos, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.homeIssuerId), size: "small", insuranceType: InsuranceType.Home })),
                    },
                }
                : undefined, selected: {
                auto: {
                    price: bundleAutoDollars,
                    logo: (React.createElement(ConnectIssuerIcon, { issuerId: (_f = bundle === null || bundle === void 0 ? void 0 : bundle.auto) === null || _f === void 0 ? void 0 : _f.issuerId, fallback: hideIssuerLogos && sameAutoPolicy, size: "small", insuranceType: InsuranceType.Auto })),
                    estimate: !samePolicy && !isAutoRC2,
                },
                home: {
                    price: bundleHomeDollars,
                    logo: (React.createElement(SavvyIssuerIcon, { issuerId: (_g = bundle === null || bundle === void 0 ? void 0 : bundle.home) === null || _g === void 0 ? void 0 : _g.issuerId, fallback: hideIssuerLogos && sameHomePolicy, size: "small", insuranceType: InsuranceType.Home })),
                    estimate: !samePolicy && !isHomeRC2,
                },
            } })));
}
function PaymentCollection(_a) {
    var isLinked = _a.isLinked, handleClick = _a.handleClick, hasSavings = _a.hasSavings;
    var steps = [
        "Enter Payment Details",
        "Review Quote with Agent",
        "Checkout",
        "Cancel Old Policy",
    ];
    return (React.createElement("section", { className: "text-center" },
        React.createElement(Subtitle, null, getSubtitle({ isLinked: isLinked, numOfSteps: steps.length, hasSavings: hasSavings })),
        React.createElement(Steps, { steps: steps }),
        React.createElement(Button, { className: "transition-all hover:bg-opacity-75", onClick: handleClick }, "Continue")));
}
function BindableSteps(_a) {
    var _b, _c;
    var bundle = _a.bundle, isLinked = _a.isLinked, currentPlan = _a.currentPlan, handleClick = _a.handleClick, hasSavings = _a.hasSavings;
    var isSwitchingAuto = ((_b = bundle === null || bundle === void 0 ? void 0 : bundle.auto) === null || _b === void 0 ? void 0 : _b.issuerId) !== (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.issuerId);
    var isSwitchingHome = ((_c = bundle === null || bundle === void 0 ? void 0 : bundle.home) === null || _c === void 0 ? void 0 : _c.issuerId) !== (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.homeIssuerId);
    var steps = [
        isSwitchingAuto && "Review Auto Quote",
        isSwitchingHome && "Review Home Quote",
        "Checkout",
        "Cancel Old Policy",
    ].filter(function (step) { return typeof step === "string"; });
    var submitButtonText = steps[0];
    return (React.createElement("section", { className: "flex flex-col items-center" },
        React.createElement(Subtitle, null, getSubtitle({ isLinked: isLinked, numOfSteps: steps.length, hasSavings: hasSavings })),
        React.createElement(Steps, { steps: steps }),
        React.createElement(Button, { className: "transition-all hover:bg-opacity-75", onClick: handleClick }, submitButtonText)));
}
function InterviewSteps(_a) {
    var isLinked = _a.isLinked, handleClick = _a.handleClick, hasSavings = _a.hasSavings;
    var steps = [
        "Verify Information",
        "Review Quote with Agent",
        "Checkout",
        "Cancel Old Policy",
    ];
    return (React.createElement("section", { className: "flex flex-col items-center" },
        React.createElement(Subtitle, null, getSubtitle({ isLinked: isLinked, numOfSteps: steps.length, hasSavings: hasSavings })),
        React.createElement(Steps, { steps: steps }),
        React.createElement(Button, { className: "transition-all hover:bg-opacity-75", onClick: handleClick }, steps[0])));
}
var FulfillmentMethods;
(function (FulfillmentMethods) {
    FulfillmentMethods["checkout"] = "checkout";
    FulfillmentMethods["interview"] = "interview";
    FulfillmentMethods["payment"] = "payment";
    FulfillmentMethods["linkout"] = "linkout";
})(FulfillmentMethods || (FulfillmentMethods = {}));
var fulfillmentMethods = {
    checkout: function (url) {
        return url.includes("checkout") ||
            url === "https://switch.savvy.insure" ||
            url.includes("bind");
    },
    interview: function (url) { return url.includes("interview"); },
    payment: function (url) { return url.includes("payment"); },
    linkout: function (url) { return url.includes("savvy.insure") === false; },
};
function getFulfillmentMethod(bundle) {
    var fulfillmentMethod = Object.entries(fulfillmentMethods).find(function (method) {
        return (bundle === null || bundle === void 0 ? void 0 : bundle.redirectUrl) ? method[1](bundle.redirectUrl) : false;
    });
    return (fulfillmentMethod === null || fulfillmentMethod === void 0 ? void 0 : fulfillmentMethod[0]) || FulfillmentMethods.linkout;
}
export default function BundleReview() {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var _a = useAppSelector(function (state) { return state.applicant; }), bundle = _a.bundle, accountLinked = _a.accountLinked, accountReferenceId = _a.accountReferenceId;
    var isRemarketingSearch = useIsRemarketingSearch();
    var impressionType = useImpressionType();
    var dispatch = useAppDispatch();
    var push = useMemoryHistory().push;
    var _b = useGetSearchResultsQuery(accountReferenceId
        ? {
            accountReferenceId: accountReferenceId,
            isRemarketingSearch: isRemarketingSearch,
            impressionType: impressionType,
        }
        : skipToken, {
        selectFromResult: function (_a) {
            var data = _a.data;
            return ({
                selectedBundle: data === null || data === void 0 ? void 0 : data.bundles.find(function (_a) {
                    var id = _a.id;
                    return id === bundle.id;
                }),
                currentPlan: data === null || data === void 0 ? void 0 : data.currentPlan,
            });
        },
    }), selectedBundle = _b.selectedBundle, currentPlan = _b.currentPlan;
    var totalBundleSavings = getBundleSavings({
        currentPlan: currentPlan,
        bundle: selectedBundle,
    }).totalBundleSavings;
    var hasSavings = totalBundleSavings > 0;
    var fulfillmentMethod = getFulfillmentMethod(selectedBundle);
    var isLinked = (accountLinked === null || accountLinked === void 0 ? void 0 : accountLinked.auto) || (accountLinked === null || accountLinked === void 0 ? void 0 : accountLinked.home);
    var sameBundle = (selectedBundle === null || selectedBundle === void 0 ? void 0 : selectedBundle.auto.type) === ResultType.CurrentAutoPolicy &&
        selectedBundle.home.type === ResultType.CurrentHomePolicy;
    function handleClick(event) {
        var optionSelected = event.currentTarget.textContent;
        var openInSameWindow = shouldOpenInSameWindow();
        completedPage(__assign({ selectedOption: optionSelected, optionSelected: optionSelected }, commonAnalyticsProperties));
        if (selectedBundle === null || selectedBundle === void 0 ? void 0 : selectedBundle.clickUrl) {
            handleResultClick(selectedBundle.clickUrl, openInSameWindow);
        }
    }
    if (!selectedBundle) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement("p", { className: "font-bold leading-none text-black-100" }, "Auto + Home Summary")),
        React.createElement(AppBody, null,
            React.createElement("div", { className: classNames("overflow-auto px-4 pb-4 text-black-100", {
                    "pt-6": !isLinked,
                }) },
                React.createElement(BundleSelectCompare, { currentPlan: currentPlan, isLinked: isLinked, bundle: selectedBundle }),
                sameBundle ? (React.createElement(React.Fragment, null,
                    React.createElement(Subtitle, null,
                        "You selected to keep ",
                        React.createElement("br", null),
                        "your current auto ",
                        React.createElement("br", null),
                        "and home insurance."),
                    React.createElement(Button, { onClick: function (event) {
                            var optionSelected = event.currentTarget.textContent;
                            completedPage(__assign({ selectedOption: optionSelected, optionSelected: optionSelected }, commonAnalyticsProperties));
                            dispatch(selectAutoBundleIssuer(null));
                            push(PHASE.AUTO_OFFER_LIST);
                        } }, "Select Again"))) : fulfillmentMethod === FulfillmentMethods.checkout ? (React.createElement(BindableSteps, { currentPlan: currentPlan, isLinked: isLinked, bundle: selectedBundle, handleClick: handleClick, hasSavings: hasSavings })) : fulfillmentMethod === FulfillmentMethods.interview ? (React.createElement(InterviewSteps, { isLinked: isLinked, handleClick: handleClick, hasSavings: hasSavings })) : fulfillmentMethod === FulfillmentMethods.payment ? (React.createElement(PaymentCollection, { handleClick: handleClick, isLinked: isLinked, hasSavings: hasSavings })) : (React.createElement("div", null,
                    React.createElement(Subtitle, null,
                        "Switch and start ",
                        React.createElement("br", null),
                        "saving in just a few ",
                        React.createElement("br", null),
                        "minutes!"),
                    React.createElement(Button, { onClick: handleClick }, "Switch and Save")))))));
}
